import {
  createCameraState,
  toggleCameraLock,
  getEdgeScrollDirection,
  updateCameraState
} from '../../domain/camera.js';

/**
 * Presentation wrapper around domain camera lock / free state.
 */
export class CameraController {
  constructor(initial = {}) {
    this.state = createCameraState(initial);
    this.mouseScreen = { x: 0, y: 0 };
    this.screenSize = { w: 1, h: 1 };
    this.edgeEnabled = false;
  }

  setMouseScreen(localX, localY, width, height) {
    this.mouseScreen = { x: localX, y: localY };
    this.screenSize = { w: width, h: height };
    this.edgeEnabled = true;
  }

  toggleLock(champion) {
    this.state = toggleCameraLock(this.state, {
      x: champion.x,
      z: champion.z
    });
  }

  update(dtSeconds, champion, pressedKeys) {
    let edgeDx = 0;
    let edgeDz = 0;
    if (this.edgeEnabled) {
      const edge = getEdgeScrollDirection(
        this.mouseScreen.x,
        this.mouseScreen.y,
        this.screenSize.w,
        this.screenSize.h
      );
      edgeDx = edge.dx;
      edgeDz = edge.dz;
    }

    this.state = updateCameraState(
      this.state,
      {
        spaceHeld: !!pressedKeys[' '],
        arrowLeft: !!pressedKeys.arrowleft,
        arrowRight: !!pressedKeys.arrowright,
        arrowUp: !!pressedKeys.arrowup,
        arrowDown: !!pressedKeys.arrowdown,
        edgeDx,
        edgeDz
      },
      { x: champion.x, z: champion.z },
      dtSeconds
    );

    return this.state;
  }

  snapTo(champion) {
    this.state = {
      ...this.state,
      x: champion.x,
      z: champion.z
    };
  }

  getCenter() {
    return { x: this.state.x, z: this.state.z };
  }

  get locked() {
    return this.state.locked;
  }
}
